import { type AllShareClassMeta } from "@hsl/fund-explorer/metaSchemas";

import { type ProductType } from "../config/types";

const UK = 41;

export function keyDocType(
    jurisdiction: number,
    productType: ProductType,
): "kid" | "kiid" {
    return productType !== "pmc" && [UK].includes(jurisdiction)
        ? "kiid"
        : "kid";
}

export default function kidOrKiid(
    jurisdiction: number,
    shareClass: AllShareClassMeta,
    productType: ProductType,
): {
    type: "kiid" | "kid";
    value: AllShareClassMeta["kid"];
} {
    const { kid, kiid } = shareClass;
    const type = keyDocType(jurisdiction, productType);
    const value = type === "kiid" ? kiid : kid;
    return { type, value };
}
